import { AbstractControl, ValidatorFn } from "@angular/forms";

export function RegistruComertValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const regex = /^[jJfFcC](0[1-9]|[1-4][0-9]|5[0-2])\/\d{1,6}\/\d{4}$/;

        if (value && !regex.test(value)) {
            return { invalidRegistru: true };
        }

        return null;
    };
}